<template>
  <div class="dashboard container is-fluid">
    <component :is="dashboard" />
  </div>
</template>

<script>
import NoExiste from '@/views/NoExiste.vue'

export default {
  name: 'Dashboard',
  components: {
    NoExiste,
    'dashboard-tiemposzona': () =>
      import(
        /* webpackPrefetch: true */ '@/components/dashboard/TiemposPorZona.vue'
      ),
    'dashboard-cumplimientohora': () =>
      import(
        /* webpackPrefetch: true */ '@/components/dashboard/CumplimientoHora.vue'
      ),
    'dashboard-pedidosfuerameta': () =>
      import(
        /* webpackPrefetch: true */ '@/components/dashboard/PedidosFueraMeta.vue'
      )
  },
  computed: {
    dashboard() {
      const dashboards = ['tiemposzona', 'cumplimientohora', 'pedidosfuerameta']
      const dashboard =
        this.$route.params.dashboard?.toLowerCase() ?? dashboards[0]
      if (dashboards.includes(dashboard)) return `dashboard-${dashboard}`
      return NoExiste
    }
  }
}
</script>
